import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MediaModule} from '@spartacus/storefront';
import {RouterModule} from '@angular/router';
import {I18nModule, UrlModule} from '@spartacus/core';
import {CustomSimpleProductItemComponent} from "./custom-simple-product-item.component";

@NgModule({
  declarations: [CustomSimpleProductItemComponent],
  exports: [
    CustomSimpleProductItemComponent
  ],
    imports: [
        CommonModule,
        MediaModule,
        RouterModule,
        UrlModule,
        I18nModule
    ]
})
export class CustomSimpleProductItemModule {}
